import { compose } from '@beef/utils';
import { connect } from 'react-redux';
import { EnhancedRequestStatus } from "../../../../_shared/components/EnhancedRequestStatus";
import { getIsRedesign } from "../../../../store/common/selectors";
export var RequestStatus = compose(connect(function (state) {
  return {
    isRedesign: getIsRedesign(state)
  };
}))(EnhancedRequestStatus);